
export const moduleRoutes = {
    list: 'roles/',
};
